import config from "config"

const getToken = () => (sessionStorage.getItem("token") || localStorage.getItem("token"))

const buildAuthHeaders = (includeContentType = true) => ({
  ...(includeContentType ? { "Content-type": "application/json" } : {}),
  Authorization: `Bearer ${getToken()}`,
})

const buildQueryString = (params = {}) => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value)
    }
  })

  const query = searchParams.toString()
  return query ? `?${query}` : ""
}

const parseResponse = async (response) => {
  if (response.status === 204) {
    return null
  }

  const contentType = response.headers.get("content-type") || ""
  if (contentType.includes("application/json")) {
    return response.json()
  }

  const text = await response.text()
  return text || null
}

const extractMessage = (payload) => {
  if (typeof payload === "string") return payload
  return payload?.message || payload?.error || null
}

const request = async (path, { method = "GET", body, includeContentType = true } = {}) => {
  const response = await fetch(`${config.api.baseURL}${path}`, {
    method,
    headers: buildAuthHeaders(includeContentType),
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  })

  if (!response.ok) {
    const errorPayload = await parseResponse(response).catch(() => null)
    const message = extractMessage(errorPayload) || `Error ${response.status} al consumir ${path}`

    const error = new Error(message)
    error.status = response.status
    throw error
  }

  return parseResponse(response)
}

async function fetchPost(data) {
  return request("/config", { method: "POST", body: data })
}

async function fetchDeviceById(id) {
  return request(`/config/${id}`)
}

async function updateDevice(id, data) {
  return request(`/config/${id}`, { method: "PUT", body: data })
}

async function deleteDevice(id) {
  return request(`/config/${id}`, { method: "DELETE" })
}

async function fetchTipos() {
  return request("/config/types")
}

async function fetchNvrDevices() {
  return request("/config/nvr")
}

async function fetchSucursales(idEmpresa) {
  return request(`/sucursales/empresa/${idEmpresa}`)
}

async function fetchEventos(idEmpresa) {
  return request(`/eventos/empresa/${idEmpresa}`)
}

async function fetchEmpresas() {
  return request("/empresas")
}

async function fetchZonas(idSucursal) {
  return request(`/zonas${buildQueryString({ idSucursal })}`)
}

async function fetchZonasBySucursal(idSucursal) {
  return request(`/zonas/sucursal/${idSucursal}`)
}

async function fetchDeviceConfigs(page = 0, size = 10, filters = {}) {
  const query = buildQueryString({ page, size, ...filters })
  return request(`/config${query}`)
}

async function toggleEnableStatus(identificador, enableDisable = false) {
  const action = !enableDisable ? "deactivate" : "activate"
  return request(`/config/${identificador}/${action}`, { method: "PUT" })
}

async function toggleOnlineStatus(identificador) {
  return request(`/config/status/${identificador}`)
}

async function checkEnableStatus(identificador) {
  return request(`/config/check-enable/${identificador}`)
}

async function openDoor(id) {
  return request(`/config/${id}/door/1/open`, { method: "PUT" })
}

export {
  updateDevice,
  fetchZonas,
  fetchEmpresas,
  fetchDeviceById,
  fetchTipos,
  fetchNvrDevices,
  fetchPost,
  fetchSucursales,
  fetchEventos,
  fetchDeviceConfigs,
  toggleEnableStatus,
  toggleOnlineStatus,
  checkEnableStatus,
  fetchZonasBySucursal,
  deleteDevice,
  openDoor,
  extractMessage,
}
